import { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useMyUser } from '../hooks/data-hooks/useMyUser'
import { ApiError } from '../lib/ApiError'
import { ROUTES } from '../lib/constants'

/**
 * Component that handles authentication redirects
 * Must be rendered inside router context
 */
export function AuthRedirectHandler() {
  const location = useLocation()
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  const { data: { data: user } = {}, isLoading } = useMyUser({
    options: {
      retry: (_failureCount, error) => {
        if (error instanceof ApiError && error.statusCode === 401) {
          return false
        }
        return true
      },
    },
  })

  useEffect(() => {
    if (isLoading) {
      return
    }

    const currentPath = location.pathname

    // Redirect authenticated users away from auth pages
    if (
      user &&
      [ROUTES.homepage, ROUTES.login, ROUTES.signup].includes(currentPath)
    ) {
      navigate(
        ROUTES.me + (searchParams.size ? `?${searchParams.toString()}` : ''),
        { replace: true }
      )
    }
  }, [user, isLoading, location.pathname, navigate])

  return null
}
